import { RULES, EPS } from './rules';
import type { MortgageResult, Verdict } from './types';

/**
 * Two-axis verdict classification (Finavest W1 matrix):
 *
 *   axis 1 — Tragbarkeit  R = ratio (annual cost / income)
 *   axis 2 — Belehnung    LTV
 *
 *   R > 1/3                       -> 'schwierig'  (Tragbarkeit not met; soft-framed, offer Spezialprüfung)
 *   R <= 1/3 & LTV > 0.80         -> 'spezial'    (min. 20% equity not met, incl. 90–100% / 0%-EK route)
 *   R <= 0.30 & LTV <= 0.80       -> 'machbar'
 *   0.30 < R <= 1/3 & LTV <= 0.80 -> 'knapp'
 *
 * Ordering matters: Tragbarkeit dominates, then LTV > 0.80 routes to
 * Spezialprüfung (never red) BEFORE the green/yellow split — so a low-equity
 * case is an invitation to talk, not a dead end.
 */
export function classifyVerdict(result: Pick<MortgageResult, 'ratio' | 'ltv'>): Verdict {
  const { ratio, ltv } = result;

  if (ratio > RULES.affordabilityMax + EPS) return 'schwierig';
  if (ltv > RULES.bankStandardLtv + EPS) return 'spezial';
  if (ratio <= RULES.greenMax + EPS) return 'machbar';
  return 'knapp';
}
